import React, { createContext, useContext, useState } from 'react';
import authService from '../services/auth.service';

// Equivale a uma variável global de sessão no ADVPL (cGetSxNum, cUserName, etc.)
// Aqui qualquer componente pode acessar o usuário logado e funções de login/logout

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(() => authService.getUsuarioLogado());

  const login = async (email, senha) => {
    const data = await authService.login(email, senha);
    localStorage.setItem('token', data.token);
    localStorage.setItem('usuario', JSON.stringify(data.usuario));
    setUsuario(data.usuario);
    return data.usuario;
  };

  const logout = () => {
    authService.logout();
    setUsuario(null);
  };

  // r128: atualiza campos do usuário logado em tempo real (sem precisar relogar).
  // Útil pra refletir mudança de foto, nome amigável, etc. quando o próprio
  // usuário edita seu cadastro. Persiste no localStorage pra sobreviver F5.
  const atualizarUsuario = (campos) => {
    setUsuario(atual => {
      if (!atual) return atual;
      const novo = { ...atual, ...campos };
      localStorage.setItem('usuario', JSON.stringify(novo));
      return novo;
    });
  };

  return (
    <AuthContext.Provider value={{ usuario, login, logout, atualizarUsuario, isAutenticado: !!usuario }}>
      {children}
    </AuthContext.Provider>
  );
}

// Hook para usar o contexto em qualquer componente
// Uso: const { usuario, login, logout } = useAuth();
export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth precisa estar dentro de <AuthProvider>');
  return ctx;
}
